import { render, staticRenderFns } from "./AtomIconDisc.vue?vue&type=template&id=5402ed7b&functional=true&"
import script from "./AtomIconDisc.vue?vue&type=script&lang=ts&"
export * from "./AtomIconDisc.vue?vue&type=script&lang=ts&"
import style0 from "./AtomIconDisc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports